import { CheckIcon, ClockIcon } from 'assets/icons';
import Badge from 'components/badge/badge';
import { doneText, dueText, isLate } from 'helper/taskDates';
import { linkKey, taskLinks } from 'helper/taskLinks';
import { durationLabel } from 'helper/timeLabels';
import useText from 'hooks/useText';
import TaskContactCard from './TaskContactCard';
import TaskDescriptionField from './TaskDescriptionField';

/**
 * The « Détail » tab of a task: its due day (red when late) or the day it was
 * done, every record it is linked to, its description. A task has a single
 * kind: no type badge, no e-mail to send. `openerOf(link)`: what opens a
 * linked record, or null.
 */
const TaskDetailTab = ({ task, openerOf, onSave, canEdit = true }) => {
  const { text } = useText('tasks');
  const now = new Date();
  const late = isLate(task, now);
  const links = taskLinks(task);
  const when = task.dueTime
    ? `${dueText(task, now, text)}, ${task.dueTime.slice(0, 5)} · ${durationLabel(task.durationMin ?? 15)}`
    : dueText(task, now, text);
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-1.5">
        {task.doneAt ? (
          <Badge type="VALID">
            <CheckIcon w={12} h={9} color="currentColor" />
            {doneText(task, text)}
          </Badge>
        ) : (
          <Badge type={late ? 'ALERT' : 'PRIMARY'}>
            <ClockIcon wh={14} color="currentColor" />
            {when}
          </Badge>
        )}
      </div>
      {links.length > 0 && (
        <div className="flex flex-col gap-2">
          {links.map((link) => (
            <TaskContactCard key={linkKey(link)} link={link} task={task} onOpen={openerOf(link)} />
          ))}
        </div>
      )}
      <TaskDescriptionField
        key={task.id}
        initial={task.note ?? ''}
        onSave={(note) => onSave({ note })}
        canEdit={canEdit}
      />
    </div>
  );
};

export default TaskDetailTab;
